// extracted by mini-css-extract-plugin
module.exports = {"article":"page_article__QfoPQ","vrmLookupBlog":"page_vrmLookupBlog__TVYeI","whyChooseFixter":"page_whyChooseFixter__whNNG","publisher":"page_publisher__sAoqn"};